import React, { FC } from 'react';

import { Section } from 'components/Layout';
import { Text, TextBlock, Watermark } from 'components/UI';

import styles from './entitledSection.module.scss';

interface IProps {
  isDark?: boolean;
  isStandAloneText?: boolean;
  title: string;
}

const EntitledSection: FC<IProps> = ({
  isDark,
  isStandAloneText,
  title,
  children,
}) => (
  <Section isDark={isDark}>
    <Watermark />
    <div className={styles.container}>
      <Text
        category="h2"
        className={styles.title}
      >
        {title}
      </Text>
      {isStandAloneText && (
        <div className={styles.text}>
          {children}
        </div>
      )}
      {!isStandAloneText && (
        <TextBlock className={styles.text}>
          {children}
        </TextBlock>
      )}
    </div>
  </Section>
);

export default EntitledSection;
